export default __webpack_public_path__ + "static/media/maison.ffe7fe57.svg";